import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/LoginView.vue'),
    meta: { title: '登录', requiresAuth: false, layout: 'blank' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/DashboardView.vue'),
    meta: { title: '首页', requiresAuth: true },
  },
  {
    path: '/pos',
    name: 'Pos',
    component: () => import('@/views/pos/PosView.vue'),
    meta: { title: '点餐操作', requiresAuth: true, layout: 'pos' },
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('@/views/orders/OrdersView.vue'),
    meta: { title: '订单管理', requiresAuth: true },
  },
  {
    path: '/members',
    name: 'Members',
    component: () => import('@/views/members/MembersView.vue'),
    meta: { title: '会员管理', requiresAuth: true },
  },
  {
    path: '/finance',
    name: 'Finance',
    component: () => import('@/views/finance/FinanceView.vue'),
    meta: { title: '财务管理', requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/settings/SettingsView.vue'),
    meta: { title: '系统设置', requiresAuth: true, requiresAdmin: true },
  },
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()

  if (to.meta.requiresAuth && !userStore.isLoggedIn()) {
    next('/login')
  } else if (to.meta.requiresAdmin && !userStore.isAdmin()) {
    next('/dashboard')
  } else if (to.path === '/login' && userStore.isLoggedIn()) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
